// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__3niGs","searchBar__input":"SearchBar_searchBar__input__2544R"};